export default __webpack_public_path__ + "static/logo-400-b6c80456ed853fdaa9e5753775c5cded.png";